export function BigLight({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 324.663 324.663"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="162.332"
        cy="162.332"
        r="162.332"
        fill="url(#big-light-gradient)"
      />
      <defs>
        <radialGradient
          id="big-light-gradient"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(162.332 162.332) rotate(90) scale(162.332)"
        >
          <stop stopColor="#F7FFC1" stopOpacity="0.3" />
          <stop offset="0.8" stopColor="#F7FFC1" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  )
}
